import {Mapper} from '@s-ui/domain'

export class FromVehicleOffersListRawDataToVehicleOffersListValueObjectMapper extends Mapper {
  constructor({
    offerPriceValueObjectFactory,
    vehicleEntityFactory,
    vehicleOffersListValueObjectFactory,
    vehicleOfferValueObjectFactory
  }) {
    super()
    this._offerPriceValueObjectFactory = offerPriceValueObjectFactory
    this._vehicleEntityFactory = vehicleEntityFactory
    this._vehicleOffersListValueObjectFactory = vehicleOffersListValueObjectFactory
    this._vehicleOfferValueObjectFactory = vehicleOfferValueObjectFactory
  }

  map = ({plateRegistrationYear, vehicles}) => {
    const items = vehicles.map(
      ({
        acceleration,
        bodyType,
        bodyTypeId,
        doors,
        expandedTrunkCapacity,
        fuelType,
        fuelTypeId,
        height,
        hp,
        id,
        imageUrlPath,
        interiorDimensions,
        length,
        make,
        makeId,
        manufacturerPrice,
        model,
        modelId,
        modelYear,
        offerPrice,
        price,
        searchUrl,
        transmissionType,
        transmissionTypeId,
        trunkCapacityInLiters,
        trunkCategory,
        url,
        unladenGroundClearance,
        version,
        versionId,
        weight,
        wheelBase,
        width,
        year
      }) => {
        const vehicleEntity = this._vehicleEntityFactory({
          acceleration,
          axisDistance: wheelBase,
          bodyType,
          bodyTypeId,
          doors,
          fuelType,
          fuelTypeId,
          height,
          heightFromGround: unladenGroundClearance,
          hp,
          id,
          imageUrlPath,
          interiorDimensions,
          length,
          luggageCapacity: trunkCapacityInLiters,
          luggageCapacityExtended: expandedTrunkCapacity,
          luggageCategory: trunkCategory,
          make,
          makeId,
          model,
          modelId,
          plateRegistrationYear,
          price: price || manufacturerPrice,
          searchUrl,
          transmissionType,
          transmissionTypeId,
          url,
          version,
          versionId,
          weight,
          width,
          year: year || modelYear
        })
        const offerPriceVO = offerPrice && this._offerPriceValueObjectFactory(offerPrice)
        return this._vehicleOfferValueObjectFactory({
          offerPrice: offerPriceVO,
          vehicle: vehicleEntity
        })
      }
    )

    return this._vehicleOffersListValueObjectFactory({items})
  }
}
